var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }